import TrackingClients from '@/components/User/Pdf/TrackingClients';

const UserClientPdfTrackingClientsPage = () => {
  return <TrackingClients />;
};

export default UserClientPdfTrackingClientsPage;
